import * as ActionTypes from 'state/actions/types'
import * as Selectors from 'state/selectors'


export const initData = (payload) => ({
  type: ActionTypes.INIT_DATA,
  payload
})

export const socketReconnectionError = () => {
  return {
    type: ActionTypes.SOCKET_RECONNECTION_ERROR
  }
}

export const authCheckSession = () => {
  return {
    type: ActionTypes.AUTH_CHECK_SESSION
  }
}

export const toggleExpandMenu = () => {
  return {
    type: ActionTypes.TOGGLE_EXPAND_MENU
  }
}

export const catchApiError = error => {
  return {
    type: ActionTypes.CATCH_API_ERROR,
    error
  }
}

export const selectOrganisation = organisation => {
  return {
    type: ActionTypes.ACTIVATE_ORGANISATION,
    payload: {
      organisation
    }
  }
}

export const onNavigate = route => {
  return {
    type: ActionTypes.ON_NAVIGATE,
    payload: {
      route
    }
  }
}

export const selectAgent = agent => {
  return {
    type: `${ActionTypes.SELECT_AGENT}_PREPARE`,
    payload: {
      agent
    },
    meta: {
      finalActionType: ActionTypes.SELECT_AGENT,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveOrganisation,
          key: 'organisation'
        }
      ]
    }
  }
}

export const fetchSocketEndpoints = () => {
  return {
    type: ActionTypes.GENERAL_SOCKET_INFO_REQUEST,
    payload: {
      useApiV2: true,
      url: '/socket.info',
      method: 'get'
    }
  }
}

export const fetchProjectInfo = projectId => {
  return {
    type: `${ActionTypes.PROJECT_INFO_REQUEST}_PREPARE`,
    payload: {
      useApiV2: false,
      url: '/projects.info',
      method: 'post',
      data: {
        projectId
      }
    },
    meta: {
      finalActionType: ActionTypes.PROJECT_INFO_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveOrganisationId,
          deepLevel: [ 'data' ],
          key: 'organisationId'
        }
      ],
      meta: { 
        successActions: [
          {
            type: `${ActionTypes.SELECT_AGENT}_PREPARE`,
            meta: {
              finalActionType: ActionTypes.SELECT_AGENT,
              selectorsToPayload: [
                {
                  selector: Selectors.getActiveOrganisation,
                  key: 'organisation'
                },
                {
                  selector: Selectors.getProdAgent,
                  key: 'agent'
                }
              ]
            }
          }
        ] }
    
    }
  }
}

export const fetchProfile = () => {
  return {
    type: ActionTypes.PROFILE_REQUEST,
    payload: {
      useApiV2: true,
      url: '/profile.self',
      method: 'get'
    },
    meta: {
      successActions: [
        {
          type: ActionTypes.ACTIVATE_ORGANISATION,
          selectorsToPayload: [
            {
              selector: Selectors.getActiveOrganisation,
              key: 'organisation'
            }
          ]
        },
        fetchSocketEndpoints()
      ]
    }
  }
}

export const setToken = token => {
  return {
    type: ActionTypes.SET_TOKEN,
    payload: {
      token
    }
  }
}

export const connecting = () => {
  return {
    type: ActionTypes.CONNECTING
  }
}


export const logout = () => {
  return {
    type: ActionTypes.LOGOUT_AUTH
  }
}
